import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { safeUrl } from "Components/directives/safeUrl";
import { useReduxState } from "Shared/redux/useReduxState";

export const useMobileOffersAndDestinations = () => {
	const [kontent] = useReduxState("kontent.dealsAndDestinations.dealsAndDestinationTest.contents");

	const mobileItemTemplate = (text: string, url: string) => html`
		<a class="text-brand-secondary underline md:hover:text-brand-primary md:hover:no-underline mb-2 flex h-[26px] items-center gap-2 last:mb-0" href=${url}>
			<div class="h-1.5 w-1.5 rounded-full bg-n-blue"></div>
			<span> ${unsafeHTML(text)} </span>
		</a>
	`;

	const widgetsTemplate = () =>
		kontent.widget
			.filter((w) => w.mobiletitle.value)
			.map((w) => mobileItemTemplate(w.mobiletitle.value, w.mobilelink.value));

	const htmlTemplate = () =>
		kontent
			? html`
					<div class="flex w-full flex-col items-center px-1">
						<div
							class="my-2 flex h-[37px] w-full items-center justify-center gap-x-1 rounded-lg bg-n-cyan text-center text-white shadow-md"
						>
							<span class="text-base/none"> ${unsafeHTML(kontent.topbarIconFontawesome.value)} </span>
							<span class="text-[13px]/none"> ${unsafeHTML(kontent.topbarTitle.value)} </span>
							<span class="text-xs/none font-black italic">
								${unsafeHTML(kontent.topbarSubtitleMobile.value)}
							</span>
						</div>
						<div class="flex w-full items-center justify-between gap-4 px-1 text-sm text-n-blue">
							<div>
								${widgetsTemplate()}
								${kontent.subwidget.map((sw) => mobileItemTemplate(sw.title.value, sw.link.value))}
							</div>
							<img class="max-h-[177px] w-auto" src=${safeUrl(kontent.map[1].img)} />
						</div>
					</div>
				`
			: "";

	return { htmlTemplate };
};
